// extracted by mini-css-extract-plugin
module.exports = {"Text":"text-module--Text--2H5do","Text__container":"text-module--Text__container--3TQfV"};